import React from 'react';
import { motion } from 'framer-motion';
import { trackEvent } from '../hooks/useMetaPixel';
export function OfferSection() {
  const items = [{
    emoji: '📘',
    name: 'Ebook principal "Vuelve a Brillar con IA"',
    value: 47
  }, {
    emoji: '🙏',
    name: 'Diario de Gratitud y Manifestación',
    value: 19
  }, {
    emoji: '🤖',
    name: 'Guía de herramientas de IA',
    value: 27
  }, {
    emoji: '✅',
    name: 'Checklist Método Orgánico',
    value: 17
  }];
  return <section id="offer" className="py-24 px-4 sm:px-6 lg:px-8 bg-gradient-to-br from-[#0d0b14] via-purple-950 to-pink-950/50 text-white relative overflow-hidden" data-id="element-191">
      {/* Decorative background elements */}
      <div className="absolute inset-0 pointer-events-none" data-id="element-192">
        <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-pink-500/15 rounded-full blur-[120px]" data-id="element-193"></div>
        <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-purple-500/15 rounded-full blur-[120px]" data-id="element-194"></div>
      </div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-195">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-14" data-id="element-196">
          <motion.div animate={{
          scale: [1, 1.05, 1]
        }} transition={{
          duration: 2,
          repeat: Infinity,
          ease: 'easeInOut'
        }} className="inline-block mb-4" data-id="element-197">
            <span className="inline-block px-6 py-2 rounded-full bg-gradient-to-r from-pink-500 to-purple-500 text-white font-bold text-sm tracking-wider shadow-lg shadow-pink-500/30" data-id="element-198">
              🔥 OFERTA ESPECIAL — SOLO POR HOY 🔥
            </span>
          </motion.div>
          <h2 className="sm:text-5xl font-extrabold mb-4 text-white text-[40px] leading-tight" data-id="element-199">
            🎁 Todo lo que recibirás <br data-id="element-200" />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-pink-400 to-purple-400" data-id="element-201">
              por comprar hoy:
            </span>
          </h2>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-white/[0.07] backdrop-blur-md text-white rounded-3xl p-8 sm:p-12 shadow-2xl border border-pink-500/20 relative overflow-hidden" data-id="element-202">
          {/* Animated corner glow */}
          <motion.div animate={{
          opacity: [0.3, 0.6, 0.3]
        }} transition={{
          duration: 3,
          repeat: Infinity,
          ease: 'easeInOut'
        }} className="absolute -top-20 -right-20 w-64 h-64 bg-pink-500/20 rounded-full blur-[80px] pointer-events-none" data-id="element-203"></motion.div>

          <div className="space-y-5 mb-10 relative z-10" data-id="element-204">
            {items.map((item, i) => <motion.div key={i} initial={{
            opacity: 0,
            x: -15
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.1
          }} className="flex justify-between items-center border-b border-white/10 pb-5 last:border-0" data-id="element-205">
                <span className="text-lg font-semibold text-slate-100 flex items-center gap-3" data-id="element-206">
                  <span className="text-2xl" data-id="element-207">{item.emoji}</span>
                  {item.name}
                </span>
                <span className="text-lg text-red-400/70 line-through font-medium whitespace-nowrap ml-4" data-id="element-208">
                  US${item.value}
                </span>
              </motion.div>)}
          </div>

          <div className="flex justify-between items-center mb-10 pt-5 border-t-2 border-white/15 relative z-10" data-id="element-209">
            <span className="text-xl font-bold text-slate-300" data-id="element-210">
              💰 Valor total:
            </span>
            <span className="text-3xl font-extrabold text-red-400/80 line-through" data-id="element-211">
              US$110
            </span>
          </div>

          {/* Price highlight box */}
          <motion.div animate={{
          boxShadow: ['0 0 20px rgba(236,72,153,0.2), 0 0 40px rgba(168,85,247,0.1)', '0 0 30px rgba(236,72,153,0.4), 0 0 60px rgba(168,85,247,0.2)', '0 0 20px rgba(236,72,153,0.2), 0 0 40px rgba(168,85,247,0.1)']
        }} transition={{
          duration: 2.5,
          repeat: Infinity,
          ease: 'easeInOut'
        }} className="text-center bg-gradient-to-br from-pink-500/20 via-purple-500/15 to-pink-500/20 rounded-2xl p-10 mb-10 border border-pink-500/30 relative z-10" data-id="element-212">
            <p className="font-bold text-xl mb-1 text-emerald-400" data-id="element-213">
              🏷️ Precio hoy:
            </p>
            <div className="text-7xl sm:text-8xl font-black mb-3 text-white drop-shadow-[0_0_30px_rgba(236,72,153,0.3)]" data-id="element-214">
              US$19
            </div>
            <motion.div animate={{
            scale: [1, 1.08, 1]
          }} transition={{
            duration: 1.5,
            repeat: Infinity,
            ease: 'easeInOut'
          }} className="inline-block" data-id="element-215">
              <span className="inline-block px-5 py-2 rounded-full bg-emerald-500/20 text-emerald-400 font-extrabold text-lg border border-emerald-500/30" data-id="element-216">
                🤑 ¡Ahorras más de US$90!
              </span>
            </motion.div>
          </motion.div>

          <div className="text-center mb-10 relative z-10" data-id="element-217">
            <p className="text-lg sm:text-xl text-slate-200 font-medium leading-relaxed" data-id="element-218">
              ✨ No estás comprando solo un ebook.
              <br data-id="element-219" />
              Estás accediendo a un{' '}
              <span className="text-pink-400 font-bold" data-id="element-220">
                sistema completo
              </span>{' '}
              que combina mentalidad, hábitos y herramientas para{' '}
              <span className="text-emerald-400 font-bold" data-id="element-221">
                transformar tu vida 🚀
              </span>
            </p>
          </div>

          <motion.a href="https://pay.hotmart.com/R104785188L" target="_blank" rel="noopener noreferrer" onClick={() => trackEvent('AddToCart')} whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.95
        }} className="block w-full py-6 bg-gradient-to-r from-pink-500 via-purple-500 to-pink-500 text-white rounded-full font-extrabold text-xl sm:text-2xl shadow-2xl shadow-pink-500/40 hover:shadow-pink-500/60 transition-all text-center relative z-10 tracking-wide" data-id="element-222">
            🛒 ¡QUIERO MI KIT AHORA!
          </motion.a>

          <p className="text-center text-slate-400 text-sm mt-4 relative z-10" data-id="element-223">
            🔒 Pago 100% seguro · Acceso inmediato · Garantía de 7 días
          </p>
        </motion.div>
      </div>
    </section>;
}